<template>
	<tr>
		<td><golf-score-graphic :golf-round="golfRound"></golf-score-graphic></td>
		<td>{{ golfRound.date_played_readable }}</td>
		<td>{{ golfRound.title }}</td>
		<td><div class="flex"><course-tee-title :tee-hex="golfRound.tee.hex"></course-tee-title> {{ golfRound.course.name }}</div></td>
		<td><router-link :to="`/rounds/${golfRound.uuid}`">VIEW/EDIT</router-link></td>
	</tr>
</template>
<script>
/** @format */
export default {
	name: 'RoundListItem',
	props: {
		golfRound: {
			type: Object,
			required: true
		}
	},
	components: {
		'course-tee-title': () => import(/* webpackChunkName: "CourseTeeTitle" */ './../Course/TeeTitle'),
		'golf-score-graphic': () => import(/* webpackChunkName: "GolfScoreGraphic" */ './ScoreGraphic'),
	},
	methods: {
	},
	data() {
		return {}
	}
};
</script>
